import { render, staticRenderFns } from "./questionOrderDetail.vue?vue&type=template&id=40ca0c86&"
import script from "./questionOrderDetail.vue?vue&type=script&lang=js&"
export * from "./questionOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./questionOrderDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports